import { Draft, PayloadAction } from '@reduxjs/toolkit';
import EUserTypes from 'enums/userTypes';

import { IUserData } from '../../index';

export interface IEditUserRequestAction {
  data: {
    email: string;
    id: number;
    name: string;
    phone: string;
    type: EUserTypes;
  };
  functions: {
    closeForm: () => void;
    error: (err: any) => void;
    success: (message: string) => void;
  };
}

function editRequest(
  draft: Draft<IUserData>,
  _: PayloadAction<IEditUserRequestAction>,
) {
  draft.edit.config.isLoading = true;
}

export default editRequest;
